function debouncer<T, C extends Function>(
  func: C,
  timeout: number = 300
): CallableFunction {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: T[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
}

export default debouncer;
